import { motion, useAnimation } from "framer-motion";
import { useState } from "react";
import { benefitType } from "types/allTypes";
import { benefitSvgAni } from "utils/animation";

interface props {
  data: benefitType;
}

const EachBenefit: React.FC<props> = ({ data }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const controls = useAnimation();

  const animationStartHandler = () => {
    if (isPlaying === false) {
      controls.start("shake");
      setIsPlaying(true);
    }
  };

  return (
    <motion.li
      className="group relative w-full max-w-[320px] flex flex-col justify-start items-start card-surface p-7
       duration-300 hover:border-primary-50/40 hover:bg-white/[0.05] hover:shadow-[0_0_40px_rgba(126,92,255,0.12)]"
      onHoverStart={animationStartHandler}
      onTap={animationStartHandler}
    >
      <motion.span
        initial="hidden"
        animate={controls}
        variants={benefitSvgAni}
        onAnimationComplete={() => setIsPlaying(false)}
        className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-primary-50/15 to-secondary-75/[0.08] border border-primary-50/25 p-3.5 group-hover:border-primary-50/50 transition-[border-color] duration-300"
      >
        {data.icon}
      </motion.span>
      <h3 className="text-base font-heading font-semibold mt-6 text-white">
        {data.title}
      </h3>
      <p className="w-full mt-3 text-sm leading-relaxed text-zinc-400">
        {data.desc}
      </p>
    </motion.li>
  );
};

export default EachBenefit;
